// Auto-generated by @rangojs/router - do not edit
export const routes = {
  category: "/:categoryId/:page?",
  product: "/:productId.html",
  search: { path: "/search", search: { q: "string?", page: "number?", sort: "string?" } },
} as const;
export type routes = typeof routes;
